import { getRequest } from "../../utils/request";
import {
  GET_ABOUT_DATA,
  GET_COMMUNITY_DATA,
  GET_PRIVACY_CMS_DATA,
  GET_RESOURCE_CMS_DATA,
  GET_TERMS_CMS_DATA,
  GET_BAA_CMS_DATA,
  GET_UPCOMING_FEATURE_CMS_DATA,
  GET_INSURANCE_CMS_DATA,
  GET_MEMBERSHIP_CMS_DATA,
  GET_HOW_IT_WORKS_CMS_DATA,
  GET_ABOUT_CMS_DATA,
  GET_FAQ_CMS_DATA,
  GET_MEBEBER_BENEFITS_CMS_DATA,
  GET_SECURITY_DATA,
} from "./constants";

export const getCommunityDetailsAction = (data) => (dispatch) => {
  getRequest("community", data, dispatch, GET_COMMUNITY_DATA);
};

export const getResourceDetailsAction = (data) => (dispatch) => {
  getRequest("resource-cms", data, dispatch, GET_RESOURCE_CMS_DATA);
};

export const getUpcomingDetailsAction = (data) => (dispatch) => {
  getRequest("upcoming-feature-cms", data, dispatch, GET_UPCOMING_FEATURE_CMS_DATA);
};

export const getTermsDetailsAction = (data) => (dispatch) => {
  getRequest("terms-cms", data, dispatch, GET_TERMS_CMS_DATA);
};

export const getBaaDetailsAction = (data) => (dispatch) => {
  getRequest("get-baa-cms", data, dispatch, GET_BAA_CMS_DATA);
};

export const getSecurityDataAction = (data) => (dispatch) => {
  getRequest("get-hippa-compliance", data, dispatch, GET_SECURITY_DATA);
};

export const getPrivacyDetailsAction = (data) => (dispatch) => {
  getRequest("privacy-cms", data, dispatch, GET_PRIVACY_CMS_DATA);
};

export const getInsuranceDetailsAction = (data) => (dispatch) => {
  getRequest("insurance-cms", data, dispatch, GET_INSURANCE_CMS_DATA);
};
export const getMembershipDetailsAction = (data) => (dispatch) => {
  getRequest("admin/fetch-membership-cms?request_type=all", data, dispatch, GET_MEMBERSHIP_CMS_DATA);
};
export const getHowItWorksCMSDetails = (data) => (dispatch) => {
  getRequest("howitworks-cms", data, dispatch, GET_HOW_IT_WORKS_CMS_DATA);
};

export const getAboutDetailsAction = (data) => (dispatch) => {
  getRequest("about-cms", data, dispatch, GET_ABOUT_DATA);
};
export const getAboutCmsData = (data) => (dispatch) => {
  getRequest("about-cms", data, dispatch, GET_ABOUT_CMS_DATA);
};
export const getFaqDetailsAction = (data) => (dispatch) => {
  getRequest("admin/fetch-faq-cms", data, dispatch, GET_FAQ_CMS_DATA);
};

export const getmemberBenefitsAction = (data) => (dispatch) => {
  getRequest("community", data, dispatch, GET_MEBEBER_BENEFITS_CMS_DATA);
};
